import styled from "styled-components";
import { SVGChevronDown as SVGChevronDownComponent } from "@/lib/svg";

// Cast to fix React 17 + @types/react 18 compatibility issue
const SVGChevronDown = SVGChevronDownComponent as any;

export const Header = styled.div`
  display: flex;
  gap: 0.75rem;
  cursor: pointer;
  align-items: center;
  user-select: none;
`;

export const Label = styled.span`
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.2;
`;

export const Indicator = styled(SVGChevronDown as any)<{ $isActive?: boolean }>`
  width: 1rem;
  transform: translateY(0.125rem)
    ${({ $isActive }) => ($isActive ? "rotate(180deg)" : "rotate(0deg)")};
`;

export const Menu = styled.div`
  position: absolute;
  margin-top: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  border: solid 1px;
  border-color: ${({ theme }) => theme.colors.lightGrey};
  padding: 1rem;
  z-index: 2;
  max-height: 17.5rem;
  overflow-y: auto;

  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
`;
